import attributes from '../resources/attributes.json';

type Attributes = {
  gender: string[];
  colour_name: string[];
  size: string[];
  fabric: string[];
  strap_material: string[];
  water_resistant: string[];
  display_type: string[];
  glass_material: string[];
  sport_type: string[];
  base_metal: string[];
  plating: string[];
  ram: string[];
  storage: string[];
  storage_type: string[];
  material: string[];
  special_feature: string[];
  compatible_devices: string[];
  connectivity: string[];
  
};

const mapping = [
  {
    category: 'Fashion',
    sub_categories: ['Shirts', 'T Shirts', 'Sweatshirts', 'Kurtas & Kurta Sets', 'Jackets & Coats', 'Sweaters', 'Stoles and Scarves', 'Mufflers', 'Suits', 'Sherwanis', 'Track Shirts', 'Track Suits', 'Unstitched Fabrics', 'Dresses', 'Tops', 'Trousers', 'Capris', 'Coordinates', 'Playsuits', 'Jumpsuits', 'Shrugs & Blouses', 'Blazers & Waistcoats', 'Tights, Leggings & Jeggings', 'Track Pants', 'Jeans', 'Shorts', 'Joggers', 'Dhotis & Dhoti Pants', 'Churidars', 'Salwars', 'Dungarees & Jumpsuits', 'Skirts', 'Clothing Sets', 'Kurtis, Tunics', 'Sarees', 'Ethnic Wear', 'Palazzos', 'Dress Materials', 'Lehenga Cholis', 'Dupattas & Shawls', 'Burqas & Hijabs', 'Blouses', 'Blouse Pieces', 'Briefs', 'Boxers', 'Vests', 'Robes', 'Night Suits', 'Thermal Wear', 'Swim Bottoms', 'Swimwear', 'Bra', 'Shapewear', 'Sleepwear & Loungewear', 'Camisoles', 'Lingerie Sets & Accessories', 'Bath Robes', 'Pyjamas', 'Party Wear', 'Innerwear & Sleepwear', 'Nightwear & Loungewear', 'Socks', 'Flip-Flops & Flats', 'Sandals & Floaters', 'Backpacks', 'Trolley, Luggage & Suitcases', 'Formal Shoes', 'Casual Shoes', 'Ethnic Shoes', 'Heels'],
    attributes: [
      { key: 'Gender', value: 'gender' },
      { key: 'Colour', value: 'colour_name' },
      { key: 'Size', value: 'size' },
      { key: 'Fabric', value: 'fabric' },
    ]
  },
  {
    category: 'Fashion',
    sub_categories: ['Belts', 'Caps & Hats', 'Towels', 'Gloves', 'Stockings', 'Laces', 'Soles & Charms', 'Shoe Racks & Organisers', 'Shoe Care - Accessories', 'Handbags', 'Outdoor Shoes', 'Work & Safety Shoes', 'Boots', 'Contact Lenses', 'Eye Glasses', 'Eye Glass Frames', 'Sunglasses', 'Contact Lens Cases', 'Contact Lens Solutions', 'Contact Lens Tweezers', 'Eyeglasses Pouches & Cases', 'Microfiber Wipes', 'Eyewear Slings'],
    attributes: [
      { key: 'Gender', value: 'gender' },
      { key: 'Colour', value: 'colour_name' },
      { key: 'Size', value: 'size' },
    ]
  },
  {
    category: 'Fashion',
    sub_categories: ['Sport Shoes'],
    attributes: [
      { key: 'Gender', value: 'gender' },
      { key: 'Colour', value: 'colour_name' },
      { key: 'Size', value: 'size' },
      { key: 'Sport Type', value: 'sport_type' },
    ]
  },
  {
    category: 'Fashion',
    sub_categories: ['Watches'],
    attributes: [
      { key: 'Gender', value: 'gender' },
      { key: 'Colour', value: 'colour_name' },
      { key: 'Size', value: 'size' },
      { key: 'Strap Material', value: 'strap_material' },
      { key: 'Water Resistant', value: 'water_resistant' },
      { key: 'Display Type', value: 'display_type' },
      { key: 'Glass Material', value: 'glass_material' },
    ]
  },
  {
    category: 'Fashion',
    sub_categories: ['Bracelets', 'Chains', 'Mangalsutra', 'Anklets', 'Necklaces', 'Earrings', 'Jewellery Sets', 'Nosepins & Noserings', 'Pendants', 'Rings', 'Toe Rings', 'Gold Coins', 'Brooch', 'Keychain'],
    attributes: [
      { key: 'Gender', value: 'gender' },
      { key: 'Colour', value: 'colour_name' },
      { key: 'Size', value: 'size' },
      { key: 'Base Metal', value: 'base_metal' },
      { key: 'Plating', value: 'plating' },
    ]
  },

  //Home & Kitchen
  {
    category: 'Home & Kitchen',
    sub_categories: ['Home Decor', 'Furniture', 'Home Furnishing - Bedding and Linen', 'Electricals', 'Bathroom and Kitchen fixtures', 'Sports and Fitness Equipment', 'Cookware', 'Serveware', 'Kitchen Storage and Containers', 
      'Kitchen Tools', 'Closet/Laundry/Shoe Organization', 'Toys and Games', 'Stationery', 'Disposables and Garbage Bags', 'Paint and Wallpapers'
    ],
    attributes: [
      { key: 'Material', value: 'material' },
      { key: 'Colour', value: 'colour_name' },
    ]
  },

  {
    category: 'Home & Kitchen',
    sub_categories: ['Garden & Outdoor', 'Bins and Bathroom', 'Mops, Brushes and Scrubs', 'Hardware, Tools and Home Safety'],
    attributes: [
      { key: 'Material', value: 'material' },
    ]
  },

  {
    category: 'Home & Kitchen',
    sub_categories: ['Flowers'],
    attributes: [
      { key: 'Colour', value: 'colour_name' },
    ]
  },


  //Appliances
  {
    category: 'Appliances',
    sub_categories: ['Air Purifier', 'Dehumidifier', 'Humidifier', 'Air Cleaner Accessories', 'Air Conditioner', 'Air Conditioner Accessories', 'Air Cooler', 'Smart TV', 'Standard TV', 'Streaming Device', 'TV Accessories', 'Home Theatre Projector', 'TV Part', 'TV Remote', 'Set Top Box',
      'Electric Sewing Machine', 'Water Heater', 'Heater Cables', 'Air Heater', 'Coffee Maker', 'Beverage Maker', 'Roti Maker', 'Induction Cooktop', 'Sandwich Maker', 'Electric Cooker', 'Electric Kettle', 'Microwave Oven', 'OTG', 'Toaster', 
      'Electric Air Fryer', 'Cooking Appliance Accessories', 'Coffee Grinder', 'Food Processor', 'Pasta Maker', 
      'Food Processor Accessories', 'Blender', 'Juicer', 'Mixer Grinder', 'Wet Grinder', 
      'Dishwasher Accessories', 'Electric Chimney', 'Kitchen Accessories', 'Freezer', 
      'Refrigerator Accessories', 'Vacuum Cleaner', 'Vacuum Cleaner Parts and Accessories',
      'Washing Machine Accessories', 'Water Purifier', 'Water Cooler', 'Water Dispenser', 'Water Purifier Service Kit', 
      'Water Purifier Filter', 'Water Purifier Candle', 'Water Purifier Pipe', 'Water Purifier Accessories', 'Water Cooler Accessories', 
      'Inverter', 'Inverter Batteries', 'Battery Tray', 'Voltage Stabilizer'
    ],
    attributes: [
      { key: 'Special Feature', value: 'special_feature' }
    ]
  },

  {
    category: 'Appliances',
    sub_categories: ['Electric Brush', 'Electric Iron', 'Dishwasher', 'Refrigerator', 'Washing Machine'
    ],
    attributes: [
      { key: 'Colour', value: 'colour_name' },
      { key: 'Special Feature', value: 'special_feature' }
    ]
  },

  //Electronics
  {
    category: 'Electronics',
    sub_categories: ['Mobile Phone'],
    attributes: [
      { key: 'RAM', value: 'ram' },
      { key: 'Colour', value: 'colour_name' },
    ]
  },

  {
    category: 'Electronics',
    sub_categories: ['Smart Watch', 'Camera Bag', 'Laptop Skin', 'Laptop Stand', 'Mousepad', 'Mobile Cover', 'Mobile Mount', 'Mobile Skin Sticker', 'Smart Band', 'Watch Strap Band', 'Wearable Accessories', 'Smart Ring'],
    attributes: [
      { key: 'Colour', value: 'colour_name' }
    ]
  },

  {
    category: 'Electronics',
    sub_categories: ['Headset', 'Tracker Devices'],
    attributes: [
      { key: 'Connectivity', value: 'connectivity' }
    ]
  },

  {
    category: 'Electronics',
    sub_categories: ['Laptop'],
    attributes: [
      { key: 'RAM', value: 'ram' },
      { key: 'Colour', value: 'colour_name' },
      { key: 'Storage Type', value: 'storage_type' }
    ]
  },

  {
    category: 'Electronics',
    sub_categories: ['Desktop', 'Tablet'],
    attributes: [
      { key: 'RAM', value: 'ram' },
      { key: 'Storage Type', value: 'storage_type' }
    ]
  },

  {
    category: 'Electronics',
    sub_categories: ['Keyboard'],
    attributes: [
      { key: 'Colour', value: 'colour_name' },
      { key: 'Connectivity', value: 'connectivity' },
      { key: 'Compatible Devices', value: 'compatible_devices' }
    ]
  },

  {
    category: 'Electronics',
    sub_categories: ['Monitor', 'Microphone', 'Camera Lens', 'UPS', 'Printer Accessories', 'Pen Drive', 'Cooling Pad', 'Docking Station', 'Keyboard Guard', 'Gaming Controller', 'Gaming Chair', 
      'Video Games', 'Biometrics', 'Home Alarm', 'Smart Switch', 'Smart Lighting', 'Home Safe', 'Intercom', 'Virtual Reality Headset', '3D Glasses', '3D Modulator', 'Projector'
    ],
    attributes: [
      { key: 'Special Feature', value: 'special_feature' }
    ]
  },

  {
    category: 'Electronics',
    sub_categories: ['Mouse', 'Home Audio', 'Speaker', 'Digital Photo Frame'],
    attributes: [
      { key: 'Colour', value: 'colour_name' },
      { key: 'Connectivity', value: 'connectivity' },
      { key: 'Special Feature', value: 'special_feature' }
    ]
  },

  {
    category: 'Electronics',
    sub_categories: ['Earphone', 'True Wireless Stereo (TWS)'],
    attributes: [
      { key: 'Colour', value: 'colour_name' },
      { key: 'Connectivity', value: 'connectivity' },
    ]
  },

  {
    category: 'Electronics',
    sub_categories: ['Vehicle Audio', 'Photo Printer', 'Printer', 'Storage Drive', 'Laptop Bag', 'Video Player'],
    attributes: [
      { key: 'Connectivity', value: 'connectivity' },
      { key: 'Special Feature', value: 'special_feature' }
    ]
  },

  {
    category: 'Electronics',
    sub_categories: ['Camcorder',],
    attributes: [
      { key: 'Storage Type', value: 'storage_type' },
      { key: 'Connectivity', value: 'connectivity' },
      { key: 'Special Feature', value: 'special_feature' }
    ]
  },

  {
    category: 'Electronics',
    sub_categories: ['Camera',],
    attributes: [
      { key: 'Storage Type', value: 'storage_type' },
      { key: 'Connectivity', value: 'connectivity' },
      { key: 'Compatible Devices', value: 'compatible_devices' },
      { key: 'Special Feature', value: 'special_feature' }
    ]
  },

  {
    category: 'Electronics',
    sub_categories: ['Computer Software',],
    attributes: [
      { key: 'RAM', value: 'ram' },
      { key: 'Special Feature', value: 'special_feature' }
    ]
  },

  {
    category: 'Electronics',
    sub_categories: ['Ebook Reader',],
    attributes: [
      { key: 'Colour', value: 'colour_name' },
      { key: 'RAM', value: 'ram' },
      { key: 'Special Feature', value: 'special_feature' }
    ]
  },

  {
    category: 'Electronics',
    sub_categories: ['Home Automation',],
    attributes: [
       { key: 'Compatible Devices', value: 'compatible_devices' },
      { key: 'Special Feature', value: 'special_feature' }
    ]
  },

  {
    category: 'Electronics',
    sub_categories: ['Home Automation',],
    attributes: [
      { key: 'Colour', value: 'Smart Glasses' },
      { key: 'Special Feature', value: 'special_feature' }
    ]
  },
  
]

export const useAttributeMapper = ({ categories = [], subCategories = [] }: { categories: string[], subCategories: string[] }) => {
  const categoryList: string[] = 
    Array.isArray(categories) && categories.length ? categories.map((k) => k?.toLowerCase()) : [];
  const subCategoryList: string[] = 
    Array.isArray(subCategories) ? subCategories.map((k) => k?.toLowerCase()) : [];

  const filteredMapping = mapping.filter((k) => {
    let condition = true;
    if (categoryList.length) {
      condition = condition && categoryList.includes(k.category.toLowerCase());
    }
    if (subCategoryList.length) {
      condition = condition && k.sub_categories.some((subCategory) => subCategoryList.includes(subCategory.toLowerCase()));
    }
    return condition;
  });
  
  const attributeList = filteredMapping.flatMap((item) => item.attributes);
  const uniqueAttributes = Array.from(new Map(attributeList.map((item) => [item.value, item])).values());
  return uniqueAttributes.map((k) => ({
    label: k.key,
    key: k.value.toLowerCase(),
    value: attributes[k.value as keyof Attributes]
  }));
};

